import Nav from "@/components/Header/Nav/Nav.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import ContactForm from "@/components/ContactForm/ContactForm";
import MapBlock from "@/components/MapBlock/MapBlock.tsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

const Kontakt = () => {
  const { t } = useTranslation("pages");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>{t("kontakt.meta.title")}</title>
        <meta name="description" content={t("kontakt.meta.description")} />
      </Helmet>

      <Nav></Nav>
      <div className="sectionPage">
        <div className="container">
          <div className="sectionTitle sideP88">
            <h1 className="halfBlock">{t("kontakt.title")}</h1>
            <p className="pageSubitle halfBlock">{t("kontakt.subtitle")}</p>
          </div>
        </div>
      </div>
      <MapBlock></MapBlock>
      <ContactForm></ContactForm>
      <Footer></Footer>
    </div>
  );
};

export default Kontakt;
